import { FunctionComponent, ReactNode } from 'react';
import {
	ThemeProvider,
	MenuProvider,
} from '@montel/montelpro-shared-components/providers';
import { EventProvider } from './EventProvider';
import {
	FullPageLoader,
	MontelThemeProvider,
	themes,
} from '@montel/montelpro-shared-components-v2';
import { AuthProvider } from '@montel/montelpro-auth';

const AppProvider: FunctionComponent<{ children: ReactNode | ReactNode[] }> = ({
	children,
}) => (
	<ThemeProvider>
		<MontelThemeProvider theme={themes.dark}>
			<AuthProvider
				authServerUri={
					process.env.REACT_APP_ACCOUNT_ADMIN_AUTH_SERVER ?? ''
				}
				authProviderUri={
					process.env.REACT_APP_ACCOUNT_ADMIN_AUTH_PROVIDER ?? ''
				}
				applicationId={process.env.REACT_APP_FA_APPLICATION_ID ?? ''}
				loaderElement={<FullPageLoader />}
			>
				<EventProvider>
					<MenuProvider>{children}</MenuProvider>
				</EventProvider>
			</AuthProvider>
		</MontelThemeProvider>
	</ThemeProvider>
);

export default AppProvider;
